import { useRef, useState, useEffect } from "react";
import { StyledEditName, StyledEditNameContent, StyledEditNameActions, MediaType } from "./edit-name.styled";
import { IconButton, Typography } from "@mzc-pdc/ui";
import Tooltip from "@components_v2/Tooltip/tooltip";
import { IconEditSmall } from "@mzc-cloudplex/icons";
import { useTranslation } from "react-i18next";
import TextField from "../text-field/text-field";
import theme from "@styles/theme";

const EditName = ({
    type,
    name,
    isEdit,
    isEditable,
    mediaType,
    value,
    valueLength,
    onChange,
    onEditClick,
    actions,
    error,
    helperText,
}) => {
    const { t } = useTranslation();
    const textRef = useRef(null);
    const [isEllipsed, setIsEllipsed] = useState(false);

    useEffect(() => {
        const checkEllipsis = () => {
            if (textRef.current) {
                setIsEllipsed(textRef.current.scrollWidth > textRef.current.clientWidth);
            }
        };

        // 편집 모드에서 돌아올 때 레이아웃 완료 후 측정
        const rafId = requestAnimationFrame(checkEllipsis);

        const resizeObserver = new ResizeObserver(() => {
            requestAnimationFrame(checkEllipsis);
        });
        if (textRef.current) {
            resizeObserver.observe(textRef.current);
        }

        return () => {
            cancelAnimationFrame(rafId);
            resizeObserver.disconnect();
        };
    }, [name, isEdit]);

    return (
        <StyledEditName type={type} valueLength={valueLength} isEdit={isEdit} isEditable={isEditable}>
            <StyledEditNameContent type={type} valueLength={valueLength}>
                {mediaType && (
                    <MediaType className={"media-type"} isEdit={isEdit} type={type}>
                        {mediaType}
                    </MediaType>
                )}
                {isEdit ? (
                    <TextField
                        type={"input"}
                        value={value}
                        onChange={onChange}
                        size={"medium"}
                        id=""
                        isEdit
                        inputStyle={{
                            fontSize: type === "panel" ? (valueLength > 107 ? "14px" : "16px") : `20px`,
                            fontWeight: `bold`,
                            lineHeight: type === "panel" ? "1.2" : "1.5",
                        }}
                        sx={{
                            maxWidth: 876,
                        }}
                        error={error}
                        helperText={helperText}
                    />
                ) : (
                    <Tooltip title={isEllipsed ? name : ""} componentsProps={{ tooltip: { sx: { maxWidth: 600 } } }}>
                        <Typography ref={textRef} variant={"h3"} color={theme.palette.greySecondary.main} noWrap sx={{ minWidth: 0 }}>
                            {name}
                        </Typography>
                    </Tooltip>
                )}
                {name && isEditable && !isEdit && (
                    <Tooltip title={t(`common::label::${"Edit"}`)}>
                        <IconButton
                            className={"btn-edit"}
                            size={type === "panel" ? "xsmall" : "small"}
                            circled
                            variant={"dashed"}
                            onClick={onEditClick}
                        >
                            <IconEditSmall size={type === "panel" ? 12 : 16} />
                        </IconButton>
                    </Tooltip>
                )}
                {type === "detail" && isEdit && (
                    <StyledEditNameActions sx={{ marginLeft: 1 }}>{actions && actions}</StyledEditNameActions>
                )}
            </StyledEditNameContent>
            {type !== "detail" && isEdit && <StyledEditNameActions>{actions && actions}</StyledEditNameActions>}
        </StyledEditName>
    );
};

export default EditName;
